
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cashback/ebase",
      function () {
        return require("private-next-pages/cashback/ebase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cashback/ebase"])
      });
    }
  